import { inject } from "vue";

/**
 * Composable for accessing global handlers
 * Centralizes the injection of global error and success handlers
 */
export const useGlobalHandlers = () => {
  const globalErrorHandler = inject("globalErrorHandler") as (
    error: any
  ) => void;
  const globalWarningHandler = inject("globalWarningHandler") as (
    title: string,
    description: string
  ) => void;
  const globalSuccessHandler = inject("globalSuccessHandler") as (
    title: string,
    description: string
  ) => void;

  return {
    globalErrorHandler,
    globalWarningHandler,
    globalSuccessHandler,
  };
};
